<template>
    <div class="optpl-hero">
        <div class="optpl-hero__nav">
            <div class="optpl-hero__nav__types">
                <ul disabled>
                    <li :class="{ active: isActive('all')                }"><router-link :to="{ name: 'home'                                          }">{{ $e('All')           }}</router-link></li>
                    <li :class="{ active: isActive('templates')          }"><router-link :to="{ name: 'library', params: { type: 'templates'         }}">{{ $e('Templates') }}</router-link></li>
                    <!-- <li :class="{ active: isActive('templates-landing')  }"><router-link :to="{ name: 'library', params: { type: 'templates-landing' }}">{{ $e('Landing Pages') }}</router-link></li>
                    <li :class="{ active: isActive('templates-other')    }"><router-link :to="{ name: 'library', params: { type: 'templates-other'   }}">{{ $e('Website Pages') }}</router-link></li> -->
                    <li :class="{ active: isActive('collections')        }"><router-link :to="{ name: 'library', params: { type: 'collections'       }}">{{ $e('Collections')   }}</router-link></li>
                    <li :class="{ active: isActive('purchased')          }"><router-link :to="{ name: 'library', params: { type: 'purchased'         }}">{{ $e('Purchased')     }}</router-link></li>
                    <li :class="{ active: isActive('marketplace')        }"><router-link :to="{ name: 'library', params: { type: 'marketplace'       }}">{{ $e('Marketplace')   }}</router-link></li>
                    <li :class="{ active: isActive('my-templates')       }"><router-link :to="{ name: 'library', params: { type: 'my-templates'      }}">{{ $e('My Templates')  }}</router-link></li>
                    <li :class="{ active: isActive('favorites')          }"><router-link :to="{ name: 'library', params: { type: 'favorites'         }}"><i class="opui-fa opui-fa-heart"></i></router-link></li>
                </ul>
            </div>

            <div class="optpl-hero__nav__search">
                <i class="opui-fa opui-fa-search"></i>
                <input type="search" placeholder="Search" v-model="this.filtersStore.keyword" @input="changeKeyword">
            </div>
        </div>
    </div>
</template>

<script>
import { useFiltersStore } from "../../store/filters"
import { mapStores } from 'pinia'

export default {
    data() {
        return {
            keywordTimeoutInterval: null,
            keywordTimeoutDuration: 500,
            filtersStore:           useFiltersStore(),
        }
    },
    computed: {
        ...mapStores(useFiltersStore),
    },
    methods: {
        changeKeyword() {
            if (this.keywordTimeoutInterval)
                clearTimeout(this.keywordTimeoutInterval);

            this.keywordTimeoutInterval = setTimeout(() => this.$emit('filter'), this.keywordTimeoutDuration);
        },

        isActive(type) {
            if (type === 'all' && (this.$route.params.type === undefined/* || this.$route.params.type === 'templates'*/)) {
                return true
            }

            return this.$route.params.type === type
        },
    },
}
</script>

<style scoped>
.optpl-hero__nav__sort {
    display: flex;
    padding: 0 !important;
    align-items: center;

    span {
        margin-right: 10px;
        white-space: nowrap;
    }
}
</style>
